module.exports = __webpack_public_path__ + "media/images/zalo_inactive_white_logo_with_white_label-c0a107752f12fd2b21a42c0fcada83ec.svg";